import React from 'react';
import { School } from 'models/school';
import Collections from 'views/School/Collections';
export default function Tournaments({ school }: { school: School }) { return <Collections school={school} mode='tournaments' />; }
